<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sondict__sondict}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.dictCode" placeholder="子分类ID或子分类名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.pid" placeholder="资源分类" clearable>
            <el-option v-for="item in dictList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sondict:sondict:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sondict:sondict:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
         <el-table-column prop="dictCode" label="子分类ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="dictName" label="分类名字" header-align="center" align="center"></el-table-column>
        <el-table-column prop="type" label="类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type == 0" type="success">影视分类</el-tag>
            <el-tag v-if="scope.row.type == 1" type="success">小说分类</el-tag>
        </template>
        </el-table-column>
        <el-table-column label="父分类" header-align="center" align="center">
          <template slot-scope="scope">
            {{ dictMap[scope.row.pid] || '未知父分类' }}
          </template>
        </el-table-column>
        <el-table-column prop="pid" label="父分类ID" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sondict:sondict:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.dictCode)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sondict:sondict:delete')" type="text" size="small" @click="deleteHandle(scope.row.dictCode)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './sondict-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sondict/sondict/page',
        getDataListIsPage: true,
        exportURL: '/sondict/sondict/export',
        deleteURL: '/sondict/sondict',
        deleteIsBatch: true
      },
      dataForm: {
        dictCode: '',
        pid: ''
      },
      dictMap: {},
      dictList: []
    }
  },
  created () {
    this.$http.get('/dict/dict/page', { params: { limit: 999 } }).then(({ data: res }) => {
      if (res.code === 0) {
        this.dictList = res.data.list || []
        const map = {}
        this.dictList.forEach(item => {
          map[item.dictCode] = item.dictName
        })
        this.dictMap = map
      }
    })
  },
  components: {
    AddOrUpdate
  }
}
</script>
